import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TokenIcon } from "@gearbox-protocol/ui-kit";
import { format, fromUnixTime } from "date-fns";
import { useHydratedSDK } from "../../../sdk";
import { AddressView } from "../../parameters/AddressView";
import { TokenAmount } from "../../parameters/TokenAmount";
const RedeemersList = ({ title, redeemers }) => {
    if (!redeemers?.length) {
        return null;
    }
    return (_jsxs("div", { className: "grid grid-cols-values-2 border-x border-b", children: [_jsx("div", { className: "w-64 font-bold p-2 border-r", children: title }), _jsx("div", { className: "flex flex-col p-2 gap-y-1", children: redeemers.map(redeemer => (_jsx(RedeemerEntry, { redeemer: redeemer }, redeemer.address ?? redeemer.token))) })] }));
};
const RedeemerEntry = ({ redeemer }) => {
    const { address, token, amount, claimableAt } = redeemer;
    const sdk = useHydratedSDK();
    const meta = sdk?.tokensMeta.get(token);
    return (_jsxs("div", { className: "flex flex-row items-center gap-x-2", children: [_jsx(TokenIcon, { symbol: meta?.symbol, size: 18 }), _jsx(TokenAmount, { value: {
                    amount: BigInt(amount),
                    symbol: meta?.symbol ?? "",
                    decimals: meta?.decimals ?? 18,
                }, raw: amount }), !!address && _jsx(AddressView, { address: address, compact: true }), !!claimableAt && (_jsx("pre", { children: `claimable at ${format(fromUnixTime(Number(claimableAt)), "PPpp")}` }))] }));
};
export default RedeemersList;
